export const QUERY_USER_INSTITUTION_GROUPS = 'userInstitutionGroups'
export const QUERY_USER_BY_ID = 'userById'
export const QUERY_USER_GROUPS = 'userGroups'
